// 手机号
const formatPhone = (phone) => {
    phone = "" + phone;
    return phone.substr(0, 3) + "****" + phone.substr(7, 11);
}

// 数字转换 大写字母
const AA = (value) => {
  return String.fromCharCode(Number(value)+64);
}

export default {
  formatPhone,AA
}




// WEBPACK FOOTER //
// ./src/filters/index.js